module.exports = __webpack_public_path__ + "img/full-profile-report.f388690a.svg";